var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHorizontalBar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  width: 5,
  height: 32,
  transform: "rotate(90 32 0)",
  className: "chart-qualitative-01"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 26,
  y: 9,
  width: 5,
  height: 26,
  transform: "rotate(90 26 9)",
  className: "chart-qualitative-01"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 18,
  width: 5,
  height: 20,
  transform: "rotate(90 20 18)",
  className: "chart-qualitative-01"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 27,
  width: 5,
  height: 13,
  transform: "rotate(90 13 27)",
  className: "chart-qualitative-01"
})));
export { SvgHorizontalBar as ReactComponent };
export default __webpack_public_path__ + "horizontal_bar.b418b653f595cf881d8eff4cd07596bc.svg";